var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidgetCardShuffle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1734,
    height: 1734,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 417 0.5 L 387.5 3 L 348.5 10 L 321.5 17 L 291.5 27 L 262.5 39 Q 178.2 78.2 119 142.5 Q 67.4 197.4 35 271.5 Q 21.3 303.8 12 340.5 L 4 381.5 L 0.5 419 L 0 0 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1316.5 0 L 1734 0 L 1734 426.5 L 1733 426.5 L 1732 400.5 L 1731 399.5 L 1729 377.5 L 1723 346.5 Q 1712.3 301.7 1695 263.5 Q 1659 185.5 1601.5 129 Q 1544.1 71.4 1464.5 36 Q 1431.4 21.6 1393.5 12 L 1352.5 4 L 1329.5 2 L 1328.5 1 L 1316.5 1 L 1316.5 0 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 1733.5 1306 L 1734 1734 L 1303 1733.5 L 1340.5 1731 L 1386.5 1723 L 1416.5 1715 L 1467.5 1696 Q 1553.1 1657.1 1613 1592.5 Q 1668.6 1534.1 1702 1453.5 L 1715 1416.5 L 1725 1377.5 L 1729 1355.5 L 1730 1342.5 L 1731 1341.5 L 1733.5 1306 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0.5 1314 L 5 1358.5 L 15 1404.5 Q 26.6 1445.9 44 1481.5 Q 83.7 1561.3 146.5 1618 Q 201.5 1668.5 275.5 1700 L 320.5 1716 L 356.5 1725 L 385.5 1730 L 392.5 1730 L 393.5 1731 L 430 1733.5 L 0 1734 L 0.5 1314 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 417.5 0 L 427 0.5 L 417.5 1 L 417.5 0 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1307.5 0 L 1316 0.5 L 1307.5 1 L 1307.5 0 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 405.5 1 L 411 1.5 L 405.5 2 L 405.5 1 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1322.5 1 L 1329 1.5 L 1322.5 2 L 1322.5 1 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 395.5 2 L 401 2.5 L 395.5 3 L 395.5 2 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1333.5 2 L 1338 2.5 L 1333.5 3 L 1333.5 2 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 387.5 3 L 392 3.5 L 387.5 4 L 387.5 3 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1342.5 3 L 1346 3.5 L 1342.5 4 L 1342.5 3 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 380.5 4 L 385 4.5 L 380.5 5 L 380.5 4 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1349.5 4 L 1353 4.5 L 1349.5 5 L 1349.5 4 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 374.5 5 L 378 5.5 L 374.5 6 L 374.5 5 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1356.5 5 L 1359 5.5 L 1356.5 6 L 1356.5 5 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 368.5 6 L 372 6.5 L 368.5 7 L 368.5 6 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1362.5 6 L 1365 6.5 L 1362.5 7 L 1362.5 6 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 363.5 7 L 366 7.5 L 363.5 8 L 363.5 7 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1367.5 7 L 1371 7.5 L 1367.5 8 L 1367.5 7 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 358.5 8 L 361 8.5 L 358.5 9 L 358.5 8 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1373.5 8 L 1376 8.5 L 1373.5 9 L 1373.5 8 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 353.5 9 L 356 9.5 L 353.5 10 L 353.5 9 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1377.5 9 L 1381 9.5 L 1377.5 10 L 1377.5 9 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 348.5 10 L 351 10.5 L 348.5 11 L 348.5 10 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1382.5 10 L 1385 10.5 L 1382.5 11 L 1382.5 10 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 344.5 11 L 347 11.5 L 344.5 12 L 344.5 11 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1386.5 11 L 1389 11.5 L 1386.5 12 L 1386.5 11 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 340.5 12 L 343 12.5 L 340.5 13 L 340.5 12 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1391.5 12 L 1394 12.5 L 1391.5 13 L 1391.5 12 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 336.5 13 L 339 13.5 L 336.5 14 L 336.5 13 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1395.5 13 L 1398 13.5 L 1395.5 14 L 1395.5 13 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 332.5 14 L 335 14.5 L 332.5 15 L 332.5 14 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1402.5 15 L 1405 15.5 L 1402.5 16 L 1402.5 15 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1406.5 16 L 1409 16.5 L 1406.5 17 L 1406.5 16 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 321.5 17 L 324 17.5 L 318.5 19 L 318.5 18 L 321.5 17 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1416.5 19 L 1419 19.5 L 1416.5 20 L 1416.5 19 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1435.5 25 L 1439 26.5 L 1437.5 27 L 1435.5 25 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 291.5 27 L 293 27.5 L 289.5 29 L 289.5 28 L 291.5 27 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1451.5 31 L 1455 32.5 L 1453.5 33 L 1451.5 31 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1458.5 34 L 1462 35.5 L 1460.5 36 L 1458.5 34 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 271.5 35 L 273 35.5 L 269.5 37 L 269.5 36 L 271.5 35 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1463.5 36 L 1469 38.5 L 1467.5 39 L 1463.5 37 L 1463.5 36 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 262.5 39 L 264 39.5 L 258.5 42 L 258.5 41 L 262.5 39 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1474.5 41 L 1499 53.5 L 1497.5 53 L 1474.5 42 L 1474.5 41 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 236.5 52 L 235.5 54 L 231.5 56 L 232.5 54 L 236.5 52 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1502.5 55 L 1508 58.5 L 1506.5 58 Q 1502.5 57.5 1502.5 55 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 227.5 57 L 226.5 59 L 222.5 61 L 223.5 59 L 227.5 57 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1509.5 59 L 1513 61.5 L 1511.5 61 L 1509.5 59 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 220.5 61 L 219.5 63 L 217.5 64 L 218.5 62 L 220.5 61 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1516.5 63 L 1517.5 65 L 1516.5 63 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 215.5 64 L 214.5 66 L 209.5 69 L 210.5 67 L 215.5 64 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1519.5 65 L 1523 67.5 L 1521.5 67 L 1519.5 65 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1524.5 68 L 1544 81.5 L 1541.5 80 L 1525.5 70 L 1524.5 68 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 207.5 69 L 206.5 71 L 191.5 81 L 193.5 78 L 207.5 69 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 189.5 81 L 187.5 84 L 184.5 86 L 186.5 83 L 189.5 81 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1545.5 82 Q 1575.4 102.6 1600 128.5 L 1584.5 114 L 1547.5 85 L 1545.5 82 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 182.5 86 L 180.5 89 L 182.5 86 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 178.5 89 L 176.5 92 L 178.5 89 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 174.5 92 L 171.5 96 L 161.5 104 L 165.5 99 L 174.5 92 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 159.5 104 L 154.5 110 L 159.5 104 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 152.5 110 L 144.5 119 L 152.5 110 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 142.5 119 L 119.5 143 L 142.5 119 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1601.5 129 L 1620 148.5 L 1604 133.5 L 1601.5 129 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 118.5 144 L 110.5 153 L 118.5 144 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1620.5 150 L 1626.5 157 L 1620.5 150 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 109.5 154 L 105 159.5 L 92.5 175 L 95 171.5 L 109.5 154 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1627.5 158 L 1631.5 163 L 1627.5 158 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1632.5 164 L 1635.5 168 L 1632.5 164 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1636.5 169 L 1639.5 173 L 1636.5 169 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1640.5 174 L 1642.5 177 L 1640.5 174 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 91.5 176 L 89.5 179 L 91.5 176 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1643.5 178 L 1645.5 181 L 1643.5 178 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 88.5 180 L 86.5 183 L 88.5 180 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1646.5 182 L 1648.5 185 L 1646.5 182 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 85.5 184 L 84 186.5 L 81.5 190 L 83 187.5 L 85.5 184 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1649.5 186 L 1656 194.5 L 1653 192.5 L 1649.5 186 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 80.5 191 L 79.5 193 L 80.5 191 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 78.5 194 L 77 196.5 L 71.5 205 L 72 203.5 L 78.5 194 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1656.5 196 L 1657.5 198 L 1656.5 196 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1658.5 199 L 1659.5 201 L 1658.5 199 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1660.5 202 L 1661.5 204 L 1660.5 202 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1662.5 205 L 1667 211.5 L 1665 210.5 L 1662.5 205 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 70.5 206 L 69.5 208 L 70.5 206 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 68.5 209 L 68 210.5 L 64.5 216 L 65 214.5 L 68.5 209 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1667.5 213 L 1670 216.5 L 1668 215.5 L 1667.5 213 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 63.5 217 L 63 218.5 L 61.5 221 L 62 219.5 L 63.5 217 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1670.5 218 L 1673 221.5 L 1671 220.5 L 1670.5 218 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1673.5 223 L 1676 226.5 L 1674 225.5 L 1673.5 223 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 59.5 224 L 59 225.5 L 57.5 228 L 58 226.5 L 59.5 224 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1677.5 230 L 1682 237.5 L 1680 236.5 L 1677.5 230 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 55.5 231 L 55 232.5 L 51.5 239 L 52 237.5 L 55.5 231 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 42.5 256 L 43 257.5 L 39.5 264 L 39 262.5 L 42.5 256 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1691.5 257 L 1695 264.5 L 1694 264.5 L 1691.5 257 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 37.5 267 L 38 268.5 L 35.5 273 L 35 271.5 L 37.5 267 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1696.5 268 L 1698 271.5 L 1697 271.5 L 1696.5 268 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 34.5 274 L 35 275.5 L 33.5 278 L 33 276.5 L 34.5 274 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1699.5 275 L 1701 278.5 L 1700 278.5 L 1699.5 275 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 32.5 279 L 33 280.5 L 31.5 283 L 31 281.5 L 32.5 279 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1701.5 280 L 1703 283.5 L 1702 283.5 L 1701.5 280 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 30.5 284 L 31 285.5 L 29.5 288 L 29 286.5 L 30.5 284 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1703.5 285 L 1705 288.5 L 1704 288.5 L 1703.5 285 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 27.5 292 L 28 293.5 L 26.5 296 L 26 294.5 L 27.5 292 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1707.5 296 L 1709 299.5 L 1708 299.5 L 1707.5 296 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1713.5 313 L 1714 315.5 L 1713 315.5 L 1713.5 313 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 18.5 318 L 19 320.5 L 18 320.5 L 18.5 318 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1716.5 323 L 1717 325.5 L 1716 325.5 L 1716.5 323 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 16.5 325 L 17 327.5 L 16 327.5 L 16.5 325 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1718.5 330 L 1719 332.5 L 1718 332.5 L 1718.5 330 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 14.5 332 L 15 334.5 L 14 334.5 L 14.5 332 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1719.5 334 L 1720 336.5 L 1719 336.5 L 1719.5 334 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 13.5 336 L 14 338.5 L 13 338.5 L 13.5 336 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1720.5 338 L 1721 340.5 L 1720 340.5 L 1720.5 338 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 12.5 340 L 13 342.5 L 12 342.5 L 12.5 340 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1721.5 342 L 1722 344.5 L 1721 344.5 L 1721.5 342 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1722.5 346 L 1723 348.5 L 1722 348.5 L 1722.5 346 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 10.5 349 L 11 351.5 L 10 351.5 L 10.5 349 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1723.5 351 L 1724 353.5 L 1723 353.5 L 1723.5 351 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 9.5 353 L 10 356.5 L 9 356.5 L 9.5 353 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1724.5 356 L 1725 358.5 L 1724 358.5 L 1724.5 356 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 8.5 358 L 9 360.5 L 8 360.5 L 8.5 358 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1725.5 361 L 1726 363.5 L 1725 363.5 L 1725.5 361 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 7.5 363 L 8 366.5 L 7 366.5 L 7.5 363 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1726.5 366 L 1727 368.5 L 1726 368.5 L 1726.5 366 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 6.5 369 L 7 371.5 L 6 371.5 L 6.5 369 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1727.5 371 L 1728 374.5 L 1727 374.5 L 1727.5 371 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 5.5 375 L 6 378.5 L 5 378.5 L 5.5 375 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1728.5 377 L 1729 380.5 L 1728 380.5 L 1728.5 377 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 4.5 381 L 5 384.5 L 4 384.5 L 4.5 381 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1729.5 384 L 1730 388.5 L 1729 388.5 L 1729.5 384 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 3.5 388 L 4 392.5 L 3 392.5 L 3.5 388 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1730.5 392 L 1731 396.5 L 1730 396.5 L 1730.5 392 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 2.5 396 L 3 401.5 L 2 401.5 L 2.5 396 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1731.5 400 L 1732 405.5 L 1731 405.5 L 1731.5 400 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1.5 406 L 2 412.5 L 1 412.5 L 1.5 406 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1732.5 411 L 1733 418.5 L 1732 418.5 L 1732.5 411 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 0.5 419 L 1 428.5 L 0 428.5 L 0.5 419 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1733.5 427 L 1734 1305.5 L 1733 1305.5 L 1733.5 427 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 0.5 1304 L 1 1313.5 L 0 1313.5 L 0.5 1304 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1732.5 1314 L 1733 1321.5 L 1732 1321.5 L 1732.5 1314 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1.5 1321 L 2 1326.5 L 1 1326.5 L 1.5 1321 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1731.5 1327 L 1732 1332.5 L 1731 1332.5 L 1731.5 1327 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 2.5 1332 L 3 1336.5 L 2 1336.5 L 2.5 1332 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1730.5 1337 L 1731 1341.5 L 1730 1341.5 L 1730.5 1337 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 3.5 1341 L 4 1344.5 L 3 1344.5 L 3.5 1341 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1729.5 1345 L 1730 1348.5 L 1729 1348.5 L 1729.5 1345 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 4.5 1348 L 5 1351.5 L 4 1351.5 L 4.5 1348 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1728.5 1352 L 1729 1355.5 L 1728 1355.5 L 1728.5 1352 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 5.5 1355 L 6 1358.5 L 5 1358.5 L 5.5 1355 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1727.5 1358 L 1728 1361.5 L 1727 1361.5 L 1727.5 1358 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 6.5 1361 L 7 1364.5 L 6 1364.5 L 6.5 1361 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1726.5 1364 L 1727 1367.5 L 1726 1367.5 L 1726.5 1364 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 7.5 1367 L 8 1369.5 L 7 1369.5 L 7.5 1367 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1725.5 1369 L 1726 1372.5 L 1725 1372.5 L 1725.5 1369 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 8.5 1372 L 9 1374.5 L 8 1374.5 L 8.5 1372 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1724.5 1375 L 1725 1377.5 L 1724 1377.5 L 1724.5 1375 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 9.5 1377 L 10 1379.5 L 9 1379.5 L 9.5 1377 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1723.5 1379 L 1724 1381.5 L 1723 1381.5 L 1723.5 1379 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 10.5 1381 L 11 1383.5 L 10 1383.5 L 10.5 1381 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1722.5 1384 L 1723 1386.5 L 1722 1386.5 L 1722.5 1384 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 11.5 1386 L 12 1388.5 L 11 1388.5 L 11.5 1386 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1721.5 1388 L 1722 1390.5 L 1721 1390.5 L 1721.5 1388 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 12.5 1390 L 13 1392.5 L 12 1392.5 L 12.5 1390 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1720.5 1392 L 1721 1394.5 L 1720 1394.5 L 1720.5 1392 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 13.5 1394 L 14 1396.5 L 13 1396.5 L 13.5 1394 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1719.5 1396 L 1720 1398.5 L 1719 1398.5 L 1719.5 1396 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 14.5 1398 L 15 1400.5 L 14 1400.5 L 14.5 1398 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1718.5 1400 L 1719 1402.5 L 1718 1402.5 L 1718.5 1400 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 15.5 1402 L 16 1404.5 L 15 1404.5 L 15.5 1402 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1717.5 1404 L 1718 1406.5 L 1717 1406.5 L 1717.5 1404 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 17.5 1409 L 18 1411.5 L 17 1411.5 L 17.5 1409 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1714.5 1414 L 1715 1416.5 L 1714 1416.5 L 1714.5 1414 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 21.5 1422 L 25 1432.5 L 24 1432.5 L 21 1424.5 L 21.5 1422 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1706.5 1439 L 1707 1440.5 L 1705.5 1443 L 1705 1441.5 L 1706.5 1439 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 27.5 1440 L 29 1443.5 L 28 1443.5 L 27.5 1440 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 30.5 1448 L 32 1451.5 L 31 1451.5 L 30.5 1448 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1701.5 1452 L 1702 1453.5 L 1700.5 1456 L 1700 1454.5 L 1701.5 1452 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 32.5 1453 L 34 1456.5 L 33 1456.5 L 32.5 1453 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1698.5 1459 L 1699 1460.5 L 1697.5 1463 L 1697 1461.5 L 1698.5 1459 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 35.5 1460 L 37 1463.5 L 36 1463.5 L 35.5 1460 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1695.5 1466 L 1696 1467.5 L 1693.5 1472 L 1693 1470.5 L 1695.5 1466 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 38.5 1467 L 41 1472.5 L 40 1472.5 L 38.5 1467 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1690.5 1477 L 1691 1478.5 L 1682.5 1494 L 1683 1492.5 L 1690.5 1477 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 44.5 1480 L 51 1492.5 L 49 1491.5 L 44 1481.5 L 44.5 1480 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 53.5 1498 L 57 1503.5 L 55 1502.5 L 53.5 1498 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1679.5 1499 L 1679 1500.5 L 1676.5 1505 L 1677 1503.5 L 1679.5 1499 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 58.5 1507 L 61 1510.5 L 59 1509.5 L 58.5 1507 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1674.5 1508 L 1674 1509.5 L 1672.5 1512 L 1673 1510.5 L 1674.5 1508 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1671.5 1513 L 1671 1514.5 L 1669.5 1517 L 1670 1515.5 L 1671.5 1513 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 62.5 1514 L 65 1517.5 L 63 1516.5 L 62.5 1514 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1668.5 1518 L 1668 1519.5 L 1666.5 1522 L 1667 1520.5 L 1668.5 1518 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 65.5 1519 L 66.5 1521 L 65.5 1519 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 67.5 1522 L 70 1525.5 L 68 1524.5 L 67.5 1522 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1665.5 1523 L 1665 1524.5 L 1652.5 1543 L 1654 1540.5 L 1665.5 1523 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 70.5 1527 L 71.5 1529 L 70.5 1527 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 72.5 1530 L 73.5 1532 L 72.5 1530 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 74.5 1533 L 75.5 1535 L 74.5 1533 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 76.5 1536 L 77.5 1538 L 76.5 1536 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 78.5 1539 L 88 1551.5 L 85 1549.5 L 78.5 1539 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1651.5 1544 L 1650 1546.5 L 1647.5 1550 L 1649 1547.5 L 1651.5 1544 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1646.5 1551 L 1644.5 1554 L 1646.5 1551 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 88.5 1553 L 90.5 1556 L 88.5 1553 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1643.5 1555 L 1641.5 1558 L 1643.5 1555 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 91.5 1557 L 98 1564.5 L 94 1561.5 L 91.5 1557 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1640.5 1559 L 1638 1562.5 Q 1617.7 1590.2 1592.5 1613 L 1559.5 1641 L 1562.5 1637 Q 1589.6 1617.1 1612 1592.5 L 1640.5 1559 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 98.5 1566 L 108 1576.5 L 102 1571.5 L 98.5 1566 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 108.5 1578 L 147 1617.5 L 115 1586.5 L 108.5 1578 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 148.5 1618 L 162 1630.5 L 156.5 1626 L 148.5 1618 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 163.5 1631 L 166.5 1635 L 163.5 1631 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 168.5 1635 L 171.5 1639 L 168.5 1635 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 173.5 1639 L 184 1647.5 L 181.5 1646 Q 175.5 1643.5 173.5 1639 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1557.5 1641 L 1555.5 1644 L 1557.5 1641 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1553.5 1644 L 1551.5 1647 L 1553.5 1644 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1549.5 1647 L 1547.5 1650 L 1544.5 1652 L 1546.5 1649 L 1549.5 1647 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 185.5 1648 L 191 1652.5 L 188.5 1651 L 185.5 1648 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1542.5 1652 L 1540.5 1655 L 1526.5 1664 L 1527.5 1662 L 1542.5 1652 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 192.5 1653 L 206 1662.5 L 204.5 1662 L 194.5 1656 L 192.5 1653 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 207.5 1663 L 208.5 1665 L 207.5 1663 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1524.5 1664 L 1523.5 1666 L 1524.5 1664 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 210.5 1665 L 214 1667.5 L 212.5 1667 L 210.5 1665 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1521.5 1666 L 1520.5 1668 L 1518.5 1669 L 1519.5 1667 L 1521.5 1666 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 215.5 1668 L 216.5 1670 L 215.5 1668 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1516.5 1669 L 1515.5 1671 L 1513.5 1672 L 1514.5 1670 L 1516.5 1669 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 220.5 1671 L 224 1673.5 L 222.5 1673 L 220.5 1671 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1511.5 1672 L 1510.5 1674 L 1508.5 1675 L 1509.5 1673 L 1511.5 1672 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 225.5 1674 L 231 1677.5 L 229.5 1677 Q 225.5 1676.5 225.5 1674 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1504.5 1676 L 1503.5 1678 L 1499.5 1680 L 1500.5 1678 L 1504.5 1676 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 234.5 1679 L 246 1685.5 L 244.5 1685 L 235.5 1681 L 234.5 1679 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1491.5 1683 L 1490.5 1685 L 1481.5 1689 L 1481.5 1688 L 1491.5 1683 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 251.5 1688 L 261 1692.5 L 259.5 1693 L 251.5 1689 L 251.5 1688 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1470.5 1693 L 1472 1693.5 L 1466.5 1696 L 1466.5 1695 L 1470.5 1693 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 266.5 1695 L 270 1696.5 L 268.5 1697 L 266.5 1695 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1461.5 1697 L 1463 1697.5 L 1459.5 1699 L 1459.5 1698 L 1461.5 1697 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 273.5 1698 L 277 1699.5 L 275.5 1700 L 273.5 1698 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1456.5 1699 L 1458 1699.5 L 1454.5 1701 L 1454.5 1700 L 1456.5 1699 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 278.5 1700 L 282 1701.5 L 280.5 1702 L 278.5 1700 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1451.5 1701 L 1453 1701.5 L 1449.5 1703 L 1449.5 1702 L 1451.5 1701 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 283.5 1702 L 287 1703.5 L 285.5 1704 L 283.5 1702 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1446.5 1703 L 1448 1703.5 L 1444.5 1705 L 1444.5 1704 L 1446.5 1703 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 288.5 1704 L 292 1705.5 L 290.5 1706 L 288.5 1704 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1438.5 1706 L 1440 1706.5 L 1436.5 1708 L 1436.5 1707 L 1438.5 1706 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1417.5 1713 L 1420 1713.5 L 1414.5 1715 L 1414.5 1714 L 1417.5 1713 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 320.5 1715 L 323 1715.5 L 320.5 1716 L 320.5 1715 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1407.5 1716 L 1410 1716.5 L 1407.5 1717 L 1407.5 1716 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 327.5 1717 L 330 1717.5 L 327.5 1718 L 327.5 1717 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 331.5 1718 L 334 1718.5 L 331.5 1719 L 331.5 1718 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1400.5 1718 L 1403 1718.5 L 1400.5 1719 L 1400.5 1718 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1396.5 1719 L 1399 1719.5 L 1396.5 1720 L 1396.5 1719 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1392.5 1720 L 1395 1720.5 L 1392.5 1721 L 1392.5 1720 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 343.5 1721 L 346 1721.5 L 343.5 1722 L 343.5 1721 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1388.5 1721 L 1391 1721.5 L 1388.5 1722 L 1388.5 1721 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 347.5 1722 L 350 1722.5 L 347.5 1723 L 347.5 1722 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1384.5 1722 L 1387 1722.5 L 1384.5 1723 L 1384.5 1722 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 352.5 1723 L 355 1723.5 L 352.5 1724 L 352.5 1723 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1379.5 1723 L 1382 1723.5 L 1379.5 1724 L 1379.5 1723 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 356.5 1724 L 359 1724.5 L 356.5 1725 L 356.5 1724 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1374.5 1724 L 1377 1724.5 L 1374.5 1725 L 1374.5 1724 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 361.5 1725 L 365 1725.5 L 361.5 1726 L 361.5 1725 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1369.5 1725 L 1372 1725.5 L 1369.5 1726 L 1369.5 1725 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 366.5 1726 L 370 1726.5 L 366.5 1727 L 366.5 1726 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1364.5 1726 L 1367 1726.5 L 1364.5 1727 L 1364.5 1726 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 372.5 1727 L 376 1727.5 L 372.5 1728 L 372.5 1727 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1358.5 1727 L 1361 1727.5 L 1358.5 1728 L 1358.5 1727 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 378.5 1728 L 382 1728.5 L 378.5 1729 L 378.5 1728 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1351.5 1728 L 1355 1728.5 L 1351.5 1729 L 1351.5 1728 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 385.5 1729 L 389 1729.5 L 385.5 1730 L 385.5 1729 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1344.5 1729 L 1348 1729.5 L 1344.5 1730 L 1344.5 1729 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 393.5 1730 L 398 1730.5 L 393.5 1731 L 393.5 1730 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1336.5 1730 L 1341 1730.5 L 1336.5 1731 L 1336.5 1730 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 402.5 1731 L 408 1731.5 L 402.5 1732 L 402.5 1731 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1326.5 1731 L 1332 1731.5 L 1326.5 1732 L 1326.5 1731 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 413.5 1732 L 421 1732.5 L 413.5 1733 L 413.5 1732 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 1313.5 1732 L 1321 1732.5 L 1313.5 1733 L 1313.5 1732 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 0.5019607843137255,
    d: "M 430.5 1733 L 1303 1733.5 L 430.5 1734 L 430.5 1733 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 869.5 305 L 879 305.5 L 869.5 306 L 869.5 305 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 922.5 305 L 932 305.5 L 922.5 306 L 922.5 305 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 855.5 306 L 861 306.5 L 855.5 307 L 855.5 306 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 939.5 306 L 946 306.5 L 939.5 307 L 939.5 306 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 844.5 307 L 849 307.5 L 844.5 308 L 844.5 307 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 951.5 307 L 956 307.5 L 951.5 308 L 951.5 307 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 835.5 308 L 840 308.5 L 835.5 309 L 835.5 308 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 961.5 308 L 965 308.5 L 961.5 309 L 961.5 308 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 828.5 309 L 831 309.5 L 828.5 310 L 828.5 309 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 969.5 309 L 973 309.5 L 969.5 310 L 969.5 309 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 821.5 310 L 824 310.5 L 821.5 311 L 821.5 310 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 976.5 310 L 980 310.5 L 976.5 311 L 976.5 310 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 814.5 311 L 817 311.5 L 814.5 312 L 814.5 311 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 983.5 311 L 986 311.5 L 983.5 312 L 983.5 311 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 808.5 312 L 811 312.5 L 808.5 313 L 808.5 312 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 989.5 312 L 992 312.5 L 989.5 313 L 989.5 312 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 803.5 313 L 806 313.5 L 803.5 314 L 803.5 313 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 995.5 313 L 998 313.5 L 995.5 314 L 995.5 313 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1000.5 314 L 1003 314.5 L 1000.5 315 L 1000.5 314 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1005.5 315 L 1008 315.5 L 1005.5 316 L 1005.5 315 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 783.5 317 L 786 317.5 L 783.5 318 L 783.5 317 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1023.5 319 L 1026 319.5 L 1023.5 320 L 1023.5 319 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 464.5 361 L 467 361.5 L 464.5 362 L 464.5 361 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 476.5 361 L 479 361.5 L 476.5 362 L 476.5 361 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 655.5 364 L 654.5 366 L 655.5 364 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 451.5 367 L 450.5 369 L 451.5 367 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 491.5 367 L 492.5 369 L 491.5 367 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 496.5 371 L 503.5 379 L 496.5 371 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 445.5 373 L 444.5 375 L 445.5 373 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1166.5 376 L 1167.5 378 L 1166.5 376 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 630.5 378 L 629.5 380 L 630.5 378 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 507.5 381 L 513.5 388 L 507.5 381 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 625.5 381 L 624.5 383 L 625.5 381 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1176.5 382 L 1177.5 384 L 1176.5 382 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 617.5 386 L 616.5 388 L 617.5 386 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1184.5 387 L 1185.5 389 L 1184.5 387 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 614.5 388 L 613.5 390 L 614.5 388 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1187.5 389 L 1188.5 391 L 1187.5 389 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 611.5 390 L 610.5 392 L 611.5 390 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 518.5 391 L 524.5 398 L 518.5 391 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1190.5 391 L 1191.5 393 L 1190.5 391 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 437.5 392 L 438 394.5 L 437 394.5 L 437.5 392 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1193.5 393 L 1194.5 395 L 1193.5 393 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 605.5 394 L 604.5 396 L 605.5 394 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1196.5 395 L 1197.5 397 L 1196.5 395 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 602.5 396 L 601.5 398 L 602.5 396 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1199.5 397 L 1200.5 399 L 1199.5 397 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 599.5 398 L 598.5 400 L 599.5 398 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1202.5 399 L 1203.5 401 L 1202.5 399 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 528.5 400 L 534.5 407 L 528.5 400 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1206.5 402 L 1207.5 404 L 1206.5 402 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 592.5 403 L 591.5 405 L 592.5 403 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1209.5 404 L 1210.5 406 L 1209.5 404 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 434.5 406 L 435 408.5 L 434 408.5 L 434.5 406 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 588.5 406 L 587.5 408 L 588.5 406 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1213.5 407 L 1214.5 409 L 1213.5 407 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 585.5 408 L 583.5 411 L 585.5 408 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 539.5 410 L 545.5 417 L 539.5 410 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1217.5 410 L 1218.5 412 L 1217.5 410 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 581.5 411 L 579.5 414 L 581.5 411 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1221.5 413 L 1222.5 415 L 1221.5 413 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 577.5 414 L 575.5 417 L 577.5 414 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 432.5 415 L 433 417.5 L 432 417.5 L 432.5 415 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1225.5 416 L 1227.5 419 L 1225.5 416 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 572.5 418 L 570.5 421 L 572.5 418 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 549.5 419 L 556.5 427 L 549.5 419 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1230.5 420 L 1232.5 423 L 1230.5 420 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 567.5 422 L 565.5 425 L 567.5 422 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1235.5 424 L 1238.5 428 L 1235.5 424 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 561.5 427 L 560.5 429 L 561.5 427 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1241.5 429 L 1245.5 434 L 1241.5 429 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1249.5 436 L 1254.5 442 L 1249.5 436 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 427.5 438 L 428 440.5 L 427 440.5 L 427.5 438 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1258.5 444 L 1288.5 475 L 1258.5 444 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 878.5 449 L 889 449.5 L 878.5 450 L 878.5 449 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 911.5 449 L 923 449.5 L 911.5 450 L 911.5 449 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 865.5 450 L 870 450.5 L 865.5 451 L 865.5 450 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 930.5 450 L 936 450.5 L 930.5 451 L 930.5 450 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 855.5 451 L 859 451.5 L 855.5 452 L 855.5 451 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 941.5 451 L 945 451.5 L 941.5 452 L 941.5 451 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 847.5 452 L 851 452.5 L 847.5 453 L 847.5 452 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 950.5 452 L 953 452.5 L 950.5 453 L 950.5 452 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 840.5 453 L 844 453.5 L 840.5 454 L 840.5 453 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 957.5 453 L 960 453.5 L 957.5 454 L 957.5 453 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 834.5 454 L 837 454.5 L 834.5 455 L 834.5 454 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 963.5 454 L 966 454.5 L 963.5 455 L 963.5 454 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 829.5 455 L 832 455.5 L 829.5 456 L 829.5 455 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 969.5 455 L 972 455.5 L 969.5 456 L 969.5 455 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 974.5 456 L 977 456.5 L 974.5 457 L 974.5 456 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 979.5 457 L 982 457.5 L 979.5 458 L 979.5 457 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 814.5 458 L 817 458.5 L 814.5 459 L 814.5 458 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 422.5 461 L 423 463.5 L 422 463.5 L 422.5 461 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1292.5 479 L 1297.5 485 L 1292.5 479 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 417.5 484 L 418 486.5 L 417 486.5 L 417.5 484 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1299.5 487 L 1303.5 492 L 1299.5 487 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1305.5 494 L 1308.5 498 L 1305.5 494 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 711.5 498 L 710.5 500 L 711.5 498 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1092.5 500 L 1093.5 502 L 1092.5 500 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1310.5 500 L 1312.5 503 L 1310.5 500 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1097.5 503 L 1098.5 505 L 1097.5 503 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1314.5 505 L 1316.5 508 L 1314.5 505 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1102.5 506 L 1103.5 508 L 1102.5 506 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 412.5 507 L 413 509.5 L 412 509.5 L 412.5 507 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 696.5 507 L 695.5 509 L 696.5 507 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1318.5 510 L 1319.5 512 L 1318.5 510 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1321.5 514 L 1322.5 516 L 1321.5 514 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 410.5 516 L 411 518.5 L 410 518.5 L 410.5 516 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 681.5 517 L 680.5 519 L 681.5 517 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1120.5 518 L 1121.5 520 L 1120.5 518 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1324.5 518 L 1325.5 520 L 1324.5 518 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 678.5 519 L 677.5 521 L 678.5 519 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1123.5 520 L 1124.5 522 L 1123.5 520 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 674.5 522 L 673.5 524 L 674.5 522 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1327.5 522 L 1328.5 524 L 1327.5 522 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1127.5 523 L 1128.5 525 L 1127.5 523 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 671.5 524 L 669 527.5 L 672.5 532 L 668 527.5 L 671.5 524 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1329.5 525 L 1330.5 527 L 1329.5 525 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1131.5 526 L 1132.5 528 L 1131.5 526 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1135.5 529 L 1137.5 532 L 1135.5 529 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1332.5 529 L 1333.5 531 L 1332.5 529 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 407.5 530 L 408 532.5 L 407 532.5 L 407.5 530 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1334.5 532 L 1335.5 534 L 1334.5 532 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1140.5 533 L 1142.5 536 L 1140.5 533 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 676.5 534 L 683.5 542 L 676.5 534 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1336.5 535 L 1337.5 537 L 1336.5 535 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1145.5 537 L 1148.5 541 L 1145.5 537 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 405.5 539 L 406 541.5 L 405 541.5 L 405.5 539 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1152.5 543 L 1157.5 549 L 1152.5 543 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 687.5 544 L 693.5 551 L 687.5 544 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1344.5 547 L 1345.5 549 L 1344.5 547 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1346.5 550 L 1347.5 552 L 1346.5 550 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1161.5 551 L 1181.5 572 L 1161.5 551 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 402.5 553 L 403 555.5 L 402 555.5 L 402.5 553 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 698.5 554 L 704.5 561 L 698.5 554 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 400.5 562 L 401 564.5 L 400 564.5 L 400.5 562 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 708.5 563 L 714.5 570 L 708.5 563 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1358.5 570 L 1359.5 572 L 1358.5 570 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 719.5 573 L 728.5 583 L 719.5 573 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 397.5 576 L 398 578.5 L 397 578.5 L 397.5 576 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1185.5 576 L 1189.5 581 L 1185.5 576 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 729.5 584 L 730.5 586 L 729.5 584 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1192.5 584 L 1195.5 588 L 1192.5 584 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 395.5 585 L 396 587.5 L 395 587.5 L 395.5 585 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1197.5 590 L 1199.5 593 L 1197.5 590 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 734.5 595 L 735 597.5 L 734 597.5 L 734.5 595 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1201.5 595 L 1203.5 598 L 1201.5 595 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 392.5 599 L 393 601.5 L 392 601.5 L 392.5 599 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1205.5 600 L 1206.5 602 L 1205.5 600 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1208.5 604 L 1209.5 606 L 1208.5 604 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 390.5 608 L 391 610.5 L 390 610.5 L 390.5 608 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1211.5 608 L 1212.5 610 L 1211.5 608 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1213.5 611 L 1214.5 613 L 1213.5 611 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 731.5 618 L 730.5 620 L 731.5 618 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 727.5 624 L 723.5 629 L 727.5 624 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1225.5 629 L 1226.5 631 L 1225.5 629 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 385.5 631 L 386 633.5 L 385 633.5 L 385.5 631 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1235.5 646 L 1236.5 648 L 1235.5 646 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 380.5 654 L 381 656.5 L 380 656.5 L 380.5 654 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 375.5 677 L 376 679.5 L 375 679.5 L 375.5 677 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 691 L 373 693.5 L 372 693.5 L 372.5 691 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 372.5 704 L 373 706.5 L 372 706.5 L 372.5 704 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1415.5 715 L 1416 717.5 L 1415 717.5 L 1415.5 715 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 379.5 720 L 383.5 725 L 379.5 720 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 411.5 731 L 414 731.5 L 411.5 732 L 411.5 731 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 404.5 732 L 407 732.5 L 404.5 733 L 404.5 732 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1420.5 740 L 1421 742.5 L 1420 742.5 L 1420.5 740 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1274.5 746 L 1275 748.5 L 1274 748.5 L 1274.5 746 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1421.5 746 L 1422 748.5 L 1421 748.5 L 1421.5 746 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1422.5 752 L 1423 755.5 L 1422 755.5 L 1422.5 752 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1423.5 760 L 1424 773.5 L 1423 773.5 L 1423.5 760 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1278.5 766 L 1279 768.5 L 1278 768.5 L 1278.5 766 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1279.5 772 L 1280 774.5 L 1279 774.5 L 1279.5 772 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1422.5 778 L 1423 780.5 L 1422 780.5 L 1422.5 778 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1414.5 802 L 1413.5 804 L 1414.5 802 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1291.5 807 L 1292.5 809 L 1291.5 807 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1410.5 808 L 1409.5 810 L 1410.5 808 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1294.5 811 L 1296.5 814 L 1294.5 811 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1408.5 811 L 1405.5 815 L 1408.5 811 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1399.5 820 L 1396.5 824 L 1399.5 820 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1304.5 821 L 1306.5 824 L 1304.5 821 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1309.5 825 L 1310.5 827 L 1309.5 825 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1393.5 825 L 1392.5 827 L 1393.5 825 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1312.5 827 L 1313.5 829 L 1312.5 827 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1390.5 827 L 1389.5 829 L 1390.5 827 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1335.5 837 L 1338 837.5 L 1335.5 838 L 1335.5 837 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1365.5 837 L 1368 837.5 L 1365.5 838 L 1365.5 837 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1340.5 838 L 1345 838.5 L 1340.5 839 L 1340.5 838 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1358.5 838 L 1362 838.5 L 1358.5 839 L 1358.5 838 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 408.5 859 L 423 859.5 L 408.5 860 L 408.5 859 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 401.5 860 L 404 860.5 L 401.5 861 L 401.5 860 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 427.5 860 L 430 860.5 L 427.5 861 L 427.5 860 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 381.5 867 L 380.5 869 L 381.5 867 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 376.5 870 L 375.5 872 L 376.5 870 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 373.5 872 L 372.5 874 L 373.5 872 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 458.5 873 L 459.5 875 L 458.5 873 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 369.5 875 L 359.5 886 L 369.5 875 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 463.5 877 L 469.5 884 L 463.5 877 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 472.5 887 L 473.5 889 L 472.5 887 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 357.5 888 L 356.5 890 L 357.5 888 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 355.5 891 L 354.5 893 L 355.5 891 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 486.5 918 L 487 920.5 L 486 920.5 L 486.5 918 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 343.5 923 L 344 939.5 L 343 939.5 L 343.5 923 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 487.5 924 L 488 927.5 L 487 927.5 L 487.5 924 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 488.5 931 L 489 933.5 L 488 933.5 L 488.5 931 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 489.5 936 L 490 938.5 L 489 938.5 L 489.5 936 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 344.5 944 L 345 946.5 L 344 946.5 L 344.5 944 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 345.5 950 L 346 953.5 L 345 953.5 L 345.5 950 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 347.5 962 L 348 964.5 L 347 964.5 L 347.5 962 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1356.5 962 L 1359 962.5 L 1356.5 963 L 1356.5 962 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1368.5 962 L 1371 962.5 L 1368.5 963 L 1368.5 962 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1380.5 966 L 1381.5 968 L 1380.5 966 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1383.5 968 L 1390.5 976 L 1383.5 968 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1396.5 989 L 1397 993.5 L 1396 993.5 L 1396.5 989 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1396.5 997 L 1397 1000.5 L 1396 1000.5 L 1396.5 997 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1391.5 1023 L 1392 1025.5 L 1391 1025.5 L 1391.5 1023 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1390.5 1028 L 1391 1030.5 L 1390 1030.5 L 1390.5 1028 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1389.5 1033 L 1390 1035.5 L 1389 1035.5 L 1389.5 1033 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1383.5 1062 L 1384 1064.5 L 1383 1064.5 L 1383.5 1062 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1382.5 1067 L 1383 1069.5 L 1382 1069.5 L 1382.5 1067 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1047.5 1068 L 1041.5 1075 L 1047.5 1068 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1381.5 1072 L 1382 1074.5 L 1381 1074.5 L 1381.5 1072 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 545.5 1077 L 546.5 1079 L 545.5 1077 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 547.5 1080 L 548.5 1082 L 547.5 1080 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 549.5 1083 L 550.5 1085 L 549.5 1083 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 554.5 1090 L 555.5 1092 L 554.5 1090 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1034.5 1093 L 1035 1096.5 L 1034 1096.5 L 1034.5 1093 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 557.5 1094 L 558.5 1096 L 557.5 1094 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 559.5 1097 L 561.5 1100 L 559.5 1097 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1035.5 1101 L 1036 1103.5 L 1035 1103.5 L 1035.5 1101 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1375.5 1101 L 1376 1103.5 L 1375 1103.5 L 1375.5 1101 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 563.5 1102 L 564.5 1104 L 563.5 1102 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 566.5 1106 L 568.5 1109 L 566.5 1106 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1374.5 1106 L 1375 1108.5 L 1374 1108.5 L 1374.5 1106 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1373.5 1111 L 1374 1113.5 L 1373 1113.5 L 1373.5 1111 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 571.5 1112 L 573.5 1115 L 571.5 1112 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1041.5 1115 L 1049.5 1124 L 1041.5 1115 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 576.5 1118 L 580.5 1123 L 576.5 1118 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1053.5 1126 L 1058.5 1132 L 1053.5 1126 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 584.5 1127 L 606.5 1150 L 584.5 1127 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 407.5 1128 L 408.5 1130 L 407.5 1128 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1062.5 1134 L 1066.5 1139 L 1062.5 1134 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1367.5 1140 L 1368 1142.5 L 1367 1142.5 L 1367.5 1140 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1070.5 1141 L 1075.5 1147 L 1070.5 1141 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1366.5 1145 L 1367 1147.5 L 1366 1147.5 L 1366.5 1145 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 419.5 1148 L 420.5 1150 L 419.5 1148 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1079.5 1149 L 1084.5 1155 L 1079.5 1149 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1365.5 1150 L 1366 1152.5 L 1365 1152.5 L 1365.5 1150 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 421.5 1151 L 422.5 1153 L 421.5 1151 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 611.5 1153 L 615.5 1158 L 611.5 1153 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1088.5 1157 L 1092.5 1162 L 1088.5 1157 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 619.5 1160 L 622.5 1164 L 619.5 1160 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1096.5 1164 L 1101.5 1170 L 1096.5 1164 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 625.5 1165 L 627.5 1168 L 625.5 1165 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 431.5 1166 L 432.5 1168 L 431.5 1166 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 433.5 1169 L 434.5 1171 L 433.5 1169 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 630.5 1169 L 631.5 1171 L 630.5 1169 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1100.5 1171 L 1098.5 1174 L 1100.5 1171 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 435.5 1172 L 436.5 1174 L 435.5 1172 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 634.5 1172 L 636.5 1175 L 634.5 1172 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1096.5 1174 L 1094.5 1177 L 1096.5 1174 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 638.5 1175 L 639.5 1177 L 638.5 1175 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 438.5 1176 L 439.5 1178 L 438.5 1176 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1092.5 1177 L 1091.5 1179 L 1092.5 1177 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 642.5 1178 L 643.5 1180 L 642.5 1178 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1359.5 1179 L 1360 1181.5 L 1359 1181.5 L 1359.5 1179 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 441.5 1180 L 442.5 1182 L 441.5 1180 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1088.5 1180 L 1087.5 1182 L 1088.5 1180 Z "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1085.5 1182 L 1084.5 1184 L 1085.5 1182 Z "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 443.5 1183 L 445.5 1186 L 443.5 1183 Z "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 649.5 1183 L 650.5 1185 L 649.5 1183 Z "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1358.5 1184 L 1359 1186.5 L 1358 1186.5 L 1358.5 1184 Z "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 652.5 1185 L 653.5 1187 L 652.5 1185 Z "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 655.5 1187 L 656.5 1189 L 655.5 1187 Z "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 447.5 1188 L 448.5 1190 L 447.5 1188 Z "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 658.5 1189 L 659.5 1191 L 658.5 1189 Z "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1357.5 1189 L 1358 1191.5 L 1357 1191.5 L 1357.5 1189 Z "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1073.5 1190 L 1072.5 1192 L 1073.5 1190 Z "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 450.5 1192 L 452.5 1195 L 450.5 1192 Z "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 666.5 1194 L 667.5 1196 L 666.5 1194 Z "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1065.5 1195 L 1064.5 1197 L 1065.5 1195 Z "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 454.5 1197 L 456.5 1200 L 454.5 1197 Z "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1060.5 1198 L 1059.5 1200 L 1060.5 1198 Z "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 678.5 1201 L 679.5 1203 L 678.5 1201 Z "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 458.5 1202 L 460.5 1205 L 458.5 1202 Z "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 463.5 1208 L 466.5 1212 L 463.5 1208 Z "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1352.5 1213 L 1353 1215.5 L 1352 1215.5 L 1352.5 1213 Z "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 469.5 1215 L 473.5 1220 L 469.5 1215 Z "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1351.5 1218 L 1352 1220.5 L 1351 1220.5 L 1351.5 1218 Z "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1350.5 1223 L 1351 1225.5 L 1350 1225.5 L 1350.5 1223 Z "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 477.5 1224 L 490.5 1238 L 477.5 1224 Z "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1349.5 1228 L 1350 1230.5 L 1349 1230.5 L 1349.5 1228 Z "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 496.5 1243 L 509.5 1257 L 496.5 1243 Z "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 789.5 1243 L 792 1243.5 L 789.5 1244 L 789.5 1243 Z "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 794.5 1244 L 797 1244.5 L 794.5 1245 L 794.5 1244 Z "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 800.5 1245 L 803 1245.5 L 800.5 1246 L 800.5 1245 Z "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 931.5 1245 L 934 1245.5 L 931.5 1246 L 931.5 1245 Z "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 806.5 1246 L 809 1246.5 L 806.5 1247 L 806.5 1246 Z "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 925.5 1246 L 928 1246.5 L 925.5 1247 L 925.5 1246 Z "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 812.5 1247 L 816 1247.5 L 812.5 1248 L 812.5 1247 Z "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 918.5 1247 L 921 1247.5 L 918.5 1248 L 918.5 1247 Z "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 820.5 1248 L 824 1248.5 L 820.5 1249 L 820.5 1248 Z "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 909.5 1248 L 914 1248.5 L 909.5 1249 L 909.5 1248 Z "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 829.5 1249 L 834 1249.5 L 829.5 1250 L 829.5 1249 Z "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 899.5 1249 L 905 1249.5 L 899.5 1250 L 899.5 1249 Z "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 841.5 1250 L 850 1250.5 L 841.5 1251 L 841.5 1250 Z "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 883.5 1250 L 892 1250.5 L 883.5 1251 L 883.5 1250 Z "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1344.5 1252 L 1345 1254.5 L 1344 1254.5 L 1344.5 1252 Z "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1343.5 1257 L 1344 1259.5 L 1343 1259.5 L 1343.5 1257 Z "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 514.5 1260 L 518.5 1265 L 514.5 1260 Z "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1342.5 1262 L 1343 1264.5 L 1342 1264.5 L 1342.5 1262 Z "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 522.5 1267 L 525.5 1271 L 522.5 1267 Z "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1211.5 1267 L 1214 1268.5 L 1212.5 1268 L 1209.5 1270 L 1211.5 1267 Z "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1341.5 1267 L 1342 1269.5 L 1341 1269.5 L 1341.5 1267 Z "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1206.5 1271 L 1203.5 1275 L 1206.5 1271 Z "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1217.5 1271 L 1222.5 1277 L 1217.5 1271 Z "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 529.5 1273 L 531.5 1276 L 529.5 1273 Z "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1200.5 1276 L 1198.5 1279 L 1200.5 1276 Z "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 534.5 1277 L 537.5 1281 L 534.5 1277 Z "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1226.5 1279 L 1230.5 1284 L 1226.5 1279 Z "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1195.5 1280 L 1193.5 1283 L 1195.5 1280 Z "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 540.5 1282 L 541.5 1284 L 540.5 1282 Z "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1190.5 1284 L 1188.5 1287 L 1190.5 1284 Z "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 544.5 1285 L 546.5 1288 L 544.5 1285 Z "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1234.5 1286 L 1239.5 1292 L 1234.5 1286 Z "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1186.5 1287 L 1184.5 1290 L 1186.5 1287 Z "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 548.5 1288 L 550.5 1291 L 548.5 1288 Z "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 552.5 1291 L 554.5 1294 L 552.5 1291 Z "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1181.5 1291 L 1180.5 1293 L 1181.5 1291 Z "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1336.5 1291 L 1337 1293.5 L 1336 1293.5 L 1336.5 1291 Z "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1178.5 1293 L 1177.5 1295 L 1178.5 1293 Z "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 556.5 1294 L 557.5 1296 L 556.5 1294 Z "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1243.5 1294 L 1248.5 1300 L 1243.5 1294 Z "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1174.5 1296 L 1173.5 1298 L 1174.5 1296 Z "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1335.5 1296 L 1336 1298.5 L 1335 1298.5 L 1335.5 1296 Z "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 560.5 1297 L 561.5 1299 L 560.5 1297 Z "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 563.5 1299 L 564.5 1301 L 563.5 1299 Z "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1167.5 1301 L 1166.5 1303 L 1167.5 1301 Z "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1334.5 1301 L 1335 1303.5 L 1334 1303.5 L 1334.5 1301 Z "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1252.5 1302 L 1256.5 1307 L 1252.5 1302 Z "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1164.5 1303 L 1163.5 1305 L 1164.5 1303 Z "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1161.5 1305 L 1160.5 1307 L 1161.5 1305 Z "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1158.5 1307 L 1157.5 1309 L 1158.5 1307 Z "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1155.5 1309 L 1154.5 1311 L 1155.5 1309 Z "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1260.5 1309 L 1265.5 1315 L 1260.5 1309 Z "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 584.5 1313 L 585.5 1315 L 584.5 1313 Z "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1144.5 1316 L 1143.5 1318 L 1144.5 1316 Z "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1330.5 1316 L 1329.5 1318 L 1330.5 1316 Z "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1269.5 1317 L 1274.5 1323 L 1269.5 1317 Z "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 592.5 1318 L 593.5 1320 L 592.5 1318 Z "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1139.5 1319 L 1138.5 1321 L 1139.5 1319 Z "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1328.5 1319 L 1327.5 1321 L 1328.5 1319 Z "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 597.5 1321 L 598.5 1323 L 597.5 1321 Z "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1134.5 1322 L 1133.5 1324 L 1134.5 1322 Z "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1325.5 1323 L 1323.5 1326 L 1325.5 1323 Z "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1277.5 1324 L 1280.5 1328 L 1277.5 1324 Z "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1320.5 1327 L 1319.5 1329 L 1320.5 1327 Z "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 611.5 1329 L 612.5 1331 L 611.5 1329 Z "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1293.5 1333 L 1296 1333.5 L 1293.5 1334 L 1293.5 1333 Z "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 758.5 1384 L 761 1384.5 L 758.5 1385 L 758.5 1384 Z "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 763.5 1385 L 766 1385.5 L 763.5 1386 L 763.5 1385 Z "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 768.5 1386 L 771 1386.5 L 768.5 1387 L 768.5 1386 Z "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 774.5 1387 L 777 1387.5 L 774.5 1388 L 774.5 1387 Z "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 957.5 1387 L 960 1387.5 L 957.5 1388 L 957.5 1387 Z "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 780.5 1388 L 783 1388.5 L 780.5 1389 L 780.5 1388 Z "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 951.5 1388 L 954 1388.5 L 951.5 1389 L 951.5 1388 Z "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 786.5 1389 L 789 1389.5 L 786.5 1390 L 786.5 1389 Z "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 944.5 1389 L 948 1389.5 L 944.5 1390 L 944.5 1389 Z "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 793.5 1390 L 796 1390.5 L 793.5 1391 L 793.5 1390 Z "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 937.5 1390 L 941 1390.5 L 937.5 1391 L 937.5 1390 Z "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 800.5 1391 L 804 1391.5 L 800.5 1392 L 800.5 1391 Z "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 929.5 1391 L 933 1391.5 L 929.5 1392 L 929.5 1391 Z "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 809.5 1392 L 814 1392.5 L 809.5 1393 L 809.5 1392 Z "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 920.5 1392 L 925 1392.5 L 920.5 1393 L 920.5 1392 Z "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 819.5 1393 L 825 1393.5 L 819.5 1394 L 819.5 1393 Z "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 909.5 1393 L 915 1393.5 L 909.5 1394 L 909.5 1393 Z "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 832.5 1394 L 841 1394.5 L 832.5 1395 L 832.5 1394 Z "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 893.5 1394 L 902 1394.5 L 893.5 1395 L 893.5 1394 Z "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(211,211,208)",
    stroke: "rgb(211,211,208)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 855.5 1395 L 878 1395.5 L 855.5 1396 L 855.5 1395 Z "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 879.5 305 L 938.5 306 L 939.5 307 L 960.5 308 L 961.5 309 L 968.5 309 L 969.5 310 L 994.5 313 L 1049.5 326 L 1098.5 343 Q 1214.3 391.7 1292 478.5 Q 1348.7 540.3 1385 622.5 L 1406 679.5 L 1415 713.5 L 1423 756.5 L 1423 777.5 Q 1417.9 804.9 1400.5 820 Q 1391.2 828.7 1378.5 834 Q 1365.3 839.8 1345.5 839 L 1344.5 838 L 1333.5 837 L 1314.5 829 L 1297 814.5 Q 1288 804.5 1283 790.5 L 1275 746.5 L 1268 720.5 Q 1255.7 680.8 1237 647.5 Q 1206.1 592.4 1161.5 551 Q 1106.1 498.9 1027.5 470 L 981.5 457 L 952.5 452 L 936.5 451 L 935.5 450 L 923.5 450 L 922.5 449 L 878.5 449 L 877.5 450 L 865.5 450 L 864.5 451 L 847.5 452 L 814.5 458 L 767.5 472 Q 711 493 668 527.5 L 729 583.5 Q 736 591.5 735 607.5 Q 732.3 622.8 721.5 630 L 708.5 636 L 705.5 636 L 421.5 729 L 410.5 732 L 399.5 732 Q 385.1 728.9 378 718.5 Q 371 710.5 372 694.5 L 386 633.5 L 389 615.5 L 391 610.5 L 391 606.5 L 393 601.5 L 396 583.5 L 398 578.5 L 401 560.5 L 403 555.5 L 404 546.5 L 408 532.5 L 409 523.5 L 413 509.5 L 414 500.5 L 418 486.5 L 419 477.5 L 423 463.5 L 424 454.5 L 428 440.5 L 429 431.5 L 435 408.5 L 438 390.5 Q 440.4 376.4 449.5 369 Q 457.8 360.3 475.5 361 L 483.5 363 L 493.5 369 L 556.5 427 L 560.5 429 Q 622.3 375.3 704.5 342 L 747.5 327 L 790.5 316 L 817.5 311 L 830.5 310 L 831.5 309 L 839.5 309 L 849.5 307 L 860.5 307 L 861.5 306 L 878.5 306 L 879.5 305 Z "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    stroke: "rgb(255,255,255)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 404.5 860 L 426.5 860 L 441.5 864 Q 460.3 871.7 472 886.5 Q 479.7 895.8 484 908.5 L 493 957.5 L 505 997.5 Q 515.7 1026.8 530 1052.5 Q 561.1 1108.4 606.5 1150 Q 659.4 1199.6 733.5 1228 L 764.5 1238 L 812.5 1248 L 828.5 1249 L 829.5 1250 L 840.5 1250 L 841.5 1251 L 891.5 1251 L 892.5 1250 L 904.5 1250 L 905.5 1249 L 927.5 1247 L 957.5 1241 L 979.5 1235 L 1010.5 1224 Q 1062.1 1203.1 1102 1170.5 L 1096.5 1164 L 1040 1113.5 L 1035 1100.5 L 1035 1089.5 Q 1038.1 1074.1 1049.5 1067 L 1066.5 1060 L 1149.5 1033 L 1152.5 1031 L 1354.5 963 L 1367.5 962 Q 1383.6 964.9 1391 976.5 L 1396 987.5 L 1397 996.5 L 1369 1135.5 L 1367 1140.5 L 1361 1174.5 L 1359 1179.5 L 1354 1208.5 L 1352 1213.5 L 1346 1247.5 L 1344 1252.5 L 1338 1286.5 L 1336 1291.5 L 1334 1305.5 Q 1331.5 1320 1321.5 1327 Q 1313.2 1334.7 1296.5 1334 L 1282.5 1329 L 1211.5 1267 Q 1141.6 1329.6 1044.5 1365 L 1002.5 1378 L 950.5 1389 L 929.5 1391 L 928.5 1392 L 920.5 1392 L 919.5 1393 L 909.5 1393 L 908.5 1394 L 893.5 1394 L 892.5 1395 L 841.5 1395 L 840.5 1394 L 825.5 1394 L 824.5 1393 L 796.5 1391 L 751.5 1383 L 713.5 1373 Q 679.8 1362.7 649.5 1349 Q 557.4 1306.6 491 1238.5 Q 426.8 1174.2 386 1086.5 L 370 1047.5 L 356 1002.5 L 350 977.5 L 344 943.5 L 344 919.5 Q 350.2 889.2 371.5 874 Q 384.5 863.5 404.5 860 Z "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(93,90,80)",
    stroke: "rgb(93,90,80)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 427.5 0 L 1306.5 0 L 1307.5 1 L 1321.5 1 L 1322.5 2 L 1341.5 3 L 1342.5 4 L 1372.5 8 L 1409.5 17 Q 1441.3 26.2 1469.5 39 Q 1547.5 75 1604 132.5 Q 1656.7 185.3 1691 256.5 Q 1707.1 290.4 1718 329.5 L 1727 369.5 L 1730 396.5 L 1731 397.5 L 1731 405.5 L 1732 406.5 L 1732 418.5 L 1733 419.5 L 1733 1313.5 L 1732 1314.5 L 1731 1336.5 L 1730 1337.5 L 1730 1344.5 L 1729 1345.5 L 1727 1363.5 L 1717 1407.5 L 1707 1438.5 L 1693 1472.5 Q 1654.6 1554.1 1592.5 1612 Q 1540.9 1660.9 1472.5 1693 L 1435.5 1708 L 1403.5 1718 L 1363.5 1727 L 1336.5 1730 L 1335.5 1731 L 1313.5 1732 L 1312.5 1733 L 421.5 1733 L 420.5 1732 L 408.5 1732 L 407.5 1731 L 382.5 1729 L 337.5 1720 L 292.5 1706 L 250.5 1688 Q 171.9 1648.6 116 1586.5 Q 71 1537.5 41 1473.5 Q 26.3 1441.7 16 1405.5 L 7 1366.5 L 4 1341.5 L 3 1340.5 L 3 1332.5 L 2 1331.5 L 1 1304.5 L 0 1303.5 L 0 429.5 L 1 428.5 L 1 413.5 L 2 412.5 L 4 385.5 L 11 347.5 Q 22.9 297.4 43 255.5 Q 81.7 175.7 143.5 119 Q 199.6 66.6 275.5 34 Q 310.8 19.3 351.5 10 L 378.5 5 L 391.5 4 L 392.5 3 L 410.5 2 L 411.5 1 L 426.5 1 L 427.5 0 Z M 870 305 L 869 306 L 856 306 L 855 307 L 836 308 L 784 317 L 743 328 L 699 344 Q 620 377 560 429 L 497 371 Q 490 364 479 361 L 465 361 L 452 367 L 442 378 L 437 393 L 421 471 L 417 485 L 416 494 L 410 517 L 409 526 L 405 540 L 404 549 L 400 563 L 399 572 L 395 586 L 382 650 L 380 655 L 379 664 L 375 678 L 374 687 L 372 692 L 372 707 L 379 721 L 392 730 L 405 733 L 414 732 L 652 654 L 689 643 L 716 634 L 724 629 Q 732 622 735 610 L 735 596 L 729 583 L 669 528 Q 714 491 775 470 L 801 462 L 827 456 L 851 453 L 852 452 L 859 452 L 860 451 L 889 450 L 890 449 L 930 450 L 931 451 L 941 451 L 942 452 L 957 453 L 1004 463 L 1032 472 Q 1106 500 1159 549 Q 1205 591 1237 649 Q 1250 672 1260 699 L 1274 745 L 1281 786 Q 1285 801 1294 812 Q 1310 833 1341 839 L 1362 839 L 1372 837 Q 1386 833 1397 824 Q 1408 815 1415 803 L 1421 789 L 1424 774 L 1424 761 L 1423 760 L 1421 741 L 1411 696 L 1400 660 L 1382 615 Q 1345 535 1289 475 Q 1214 392 1105 345 L 1045 324 L 998 313 L 974 310 L 973 309 L 966 309 L 965 308 L 947 307 L 946 306 L 933 306 L 932 305 L 870 305 Z M 409 859 L 391 863 Q 378 867 370 875 Q 358 884 351 898 L 345 913 L 343 924 L 343 940 L 345 948 L 345 954 L 356 1005 Q 368 1048 385 1086 Q 421 1165 477 1225 Q 547 1302 649 1349 L 691 1366 Q 719 1376 750 1383 L 801 1392 L 819 1393 L 820 1394 L 832 1394 L 833 1395 L 855 1395 L 856 1396 L 902 1395 L 903 1394 L 915 1394 L 916 1393 L 925 1393 L 926 1392 L 948 1390 L 1005 1378 L 1049 1364 Q 1143 1329 1212 1268 L 1215 1269 L 1281 1328 L 1294 1334 Q 1304 1335 1312 1333 L 1324 1326 L 1331 1317 L 1335 1304 L 1340 1275 L 1342 1270 L 1348 1236 L 1350 1231 L 1356 1197 L 1358 1192 L 1364 1158 L 1366 1153 L 1372 1119 L 1374 1114 L 1380 1080 L 1382 1075 L 1388 1041 L 1390 1036 L 1397 1001 L 1397 990 L 1391 976 Q 1384 966 1371 962 L 1357 962 L 1057 1063 L 1048 1068 L 1039 1078 L 1036 1084 L 1034 1094 L 1035 1104 L 1041 1116 L 1102 1171 Q 1058 1205 1002 1227 L 975 1236 L 947 1243 L 918 1248 L 900 1249 L 899 1250 L 884 1250 L 883 1251 L 851 1251 L 850 1250 L 835 1250 L 834 1249 L 810 1247 L 783 1242 L 741 1230 Q 665 1202 611 1153 Q 563 1111 531 1054 Q 511 1018 498 975 L 490 942 L 486 914 L 483 905 Q 478 893 470 884 Q 459 871 443 864 L 430 860 L 409 859 Z "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetCardShuffle);
export default __webpack_public_path__ + "static/media/WIDGET_CARD_SHUFFLE.1f9f25b1fa791ff3fd7eb5feade06753.svg";
export { ForwardRef as ReactComponent };